<template>
<span class="d-flex align-items-center">
  <div id="circle" :class="ocupation"></div> <span>Ocupación {{ ocupation }}</span>
</span>
</template>

<script>
export default {
  name: 'semaforo',
  props: { 
    ocupation: { type: String, default: "baja" },
  }
  
}
</script>

<style lang="scss"  scoped>



#circle {
  /* relative */
  position: relative; 
  z-index: 5;
  width: 26px;
  height: 26px;
  background-color: rgb(255, 255, 255);
  border-radius: 50%;
  pointer-events: none;
  transition:
    background ease-in 10ms,
    box-shadow ease-in 150ms,
    transform ease-in 150ms;
  /* promote it to its own layer to enable  hardware accelerated rendering: */
  transform: translate3d(0, 0, 0);

  & + span {
    margin-left: 0.5rem;
  }

}

// background-color: #e6cf8b;
// box-shadow: 0 0 0 0 transparent, inset 0em -0.3em 0.4em 0.2em #ca9e03a6;

.baja {
  background-image: linear-gradient(to top, #31bb6d 0%, #219653 100%);

  // background-color: #219653;
  // box-shadow: 0 0 0 0 transparent, inset 0em -0.3em 0.4em 0.2em #008b3c;

  & + span {
    color:  #219653;
  }
}

.media {
  // background-color: #F2994A;
  // box-shadow: 0 0 0 0 transparent, inset 0em -0.3em 0.4em 0.2em #f1882c;

  background-image: linear-gradient(to top, #F2994A 0%, #ff7e33 100%);

  & + span {
    color:  #F2994A;
  }
}

.alta {
  // color: #B82222;
  background-image: linear-gradient(to top, #da4141 0%, #B82222 100%);

  & + span {
    color:  #B82222;
  }
}


/*  brillo  */
#box-1 {
  background-color: #e8edf3;
}
  
#box-1:hover ~ #circle {
  background-color: #e6cf8b;
  box-shadow: 0 0 0 0 transparent, inset 0em -0.3em 0.4em 0.2em #ca9e03a6;
}


 /* gradiente */
#box-4 {
  color: white;
  background-color: #22264b;
}

#box-4:hover ~ #circle {
  background-image: linear-gradient(to top, #fbc2eb 0%, #a6c1ee 100%);
}



</style>